import { ACTIVITIES_PAGE_DESCRIPTION } from '../constants/activities';
import { ANALOGY_DESCRIPTION } from '../constants/analogy';
import { CATCH_UP_FRIDAYS_DESCRIPTION } from '../constants/catchUpFridays';
import { CROSS_SUBJECT_DESCRIPTION } from '../constants/crossSubjectExtension';
import { DAILY_LESSON_LOG_DESCRIPTION } from '../constants/dailyLessonLog';
import { ELIF_DESCRIPTION } from '../constants/elif';
import { ENERGIZER_DESCRIPTION } from '../constants/energizer';
import { GENERIC_UNPACKING_DESCRIPTION } from '../constants/genericUnpacking';
import { PHOTO_BOOTH_DESCRIPTION } from '../constants/imageGeneration';
import { IPLAN_DESCRIPTION } from '../constants/iplan';
import {
  IPLAN_OBJECTIVE_PAGE_DESCRIPTION,
  OBJECTIVE_PAGE_DESCRIPTION,
} from '../constants/objective';
import { PAGE_KEY_TITLES } from '../constants/pagekeyTitles';
import { PPT_MAKER_DESCRIPTION } from '../constants/pptMaker';
import { QUIZMAKER_PAGE_DESCRIPTION } from '../constants/quizmaker';
import { SITE } from '../constants/site';
import { SUMMATIVE_TEST_PAGE_DESCRIPTION } from '../constants/summativeTest';
import { TOPIC_EXPLORER_PAGE_DESCRIPTION } from '../constants/topicExplorer';
import { UNIT_PLAN_PAGE_DESCRIPTION } from '../constants/unitPlan';
import { PageKey } from '../enums/pageKey';

interface PageSEOContent {
  title: string;
  description: string;
}

export const PAGE_DESCRIPTIONS: Partial<Record<PageKey, string>> = {
  [PageKey.activities]: ACTIVITIES_PAGE_DESCRIPTION,
  [PageKey.analogyContextualizer]: ANALOGY_DESCRIPTION,
  [PageKey.catchUpFridays]: CATCH_UP_FRIDAYS_DESCRIPTION,
  [PageKey.subjectExtention]: CROSS_SUBJECT_DESCRIPTION,
  [PageKey.dailyLessonLog]: DAILY_LESSON_LOG_DESCRIPTION,
  [PageKey.elif]: ELIF_DESCRIPTION,
  [PageKey.energizer]: ENERGIZER_DESCRIPTION,
  [PageKey.genericUnpacking]: GENERIC_UNPACKING_DESCRIPTION,
  [PageKey.lessonPlan]: SITE.description,
  [PageKey.objective]: OBJECTIVE_PAGE_DESCRIPTION,
  [PageKey.photoBooth]: PHOTO_BOOTH_DESCRIPTION,
  [PageKey.pptMaker]: PPT_MAKER_DESCRIPTION,
  [PageKey.quizMakerSingle]: QUIZMAKER_PAGE_DESCRIPTION,
  [PageKey.summativeTest]: SUMMATIVE_TEST_PAGE_DESCRIPTION,
  [PageKey.topicExplorer]: TOPIC_EXPLORER_PAGE_DESCRIPTION,
  [PageKey.unitPlan]: UNIT_PLAN_PAGE_DESCRIPTION,
  [PageKey.iplan]: IPLAN_DESCRIPTION,
  [PageKey.iplanObjective]: IPLAN_OBJECTIVE_PAGE_DESCRIPTION,
};

export function getPageSEO(pageKey: PageKey): PageSEOContent {
  const pageTitleData = PAGE_KEY_TITLES[pageKey];
  const baseTitle = pageTitleData?.pageTitle || '';
  const fullTitle = baseTitle
    ? `${baseTitle} | ${SITE.title} Org`
    : `${SITE.title}`;
  const description = PAGE_DESCRIPTIONS[pageKey] || SITE.description;

  return {
    title: fullTitle,
    description,
  };
}
